import { env } from "@/lib/env";

interface SeoProps {
  title: string;
  description: string;
  /** Absolute or root-relative canonical path. */
  path?: string;
  image?: string;
  noIndex?: boolean;
  type?: "website" | "article";
}

/**
 * React 19 hoists <title>, <meta> and <link> to <head> automatically, so no
 * helmet library is needed. Rendering these inside a route component is enough.
 */
export function Seo({ title, description, path, image, noIndex, type = "website" }: SeoProps) {
  const fullTitle = title.includes("Indraprastha") ? title : `${title} — ${env.siteName}`;
  const url = path ? `${env.siteUrl}${path}` : undefined;

  return (
    <>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {noIndex ? <meta name="robots" content="noindex" /> : null}
      {url ? <link rel="canonical" href={url} /> : null}

      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={type} />
      {url ? <meta property="og:url" content={url} /> : null}
      {image ? <meta property="og:image" content={image} /> : null}

      <meta name="twitter:card" content={image ? "summary_large_image" : "summary"} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      {image ? <meta name="twitter:image" content={image} /> : null}
    </>
  );
}
